import { createTranslationRef, createTranslationResource } from '@backstage/core-plugin-api/alpha';

export const applicationPageTranslationRef = createTranslationRef({
  id: 'application-page',
  messages: {
    applicationPage: {
      title: 'My Applications',
      subtitle: 'Application Explorer',
      pageTitleOverride: 'Applications',
      createButtonTitle: 'Register Existing Application',
      supportButtonTitle: 'All your Applications',
      searchPlaceholder: 'Filter',
      lifecycleFilterLabel: 'Lifecycle',
      typeFilterLabel: 'Type',
      selectAll: 'All',
    },
    applicationForm: {
      title: 'Application Information',
    },
    applicationTableColumns: {
      apmNumber: 'Number',
      name: 'Name',
      title: 'Title',
      division: 'Company',
      category: 'Category',
      manager: 'Business Manager',
      itManager: 'Application IT Owner',
      lifecycle: 'Lifecycle',
      applicationServices: 'Application Services',
    },
    applicationProjects: {
      title: 'Projects associated with the application',
      emptyProjects: 'No project was found associated with this application',
      moreDetails: 'More Details',
    },
    applicationRepositories: {
      title: 'Repositories associated with the application',
      emptyRepositories: 'No repository was found associated with this application',
      moreDetails: 'More Details',
      requestRepo: 'Request Repository',
    }
  },
});

export const applicationPageTranslations = createTranslationResource({
  ref: applicationPageTranslationRef,
  translations: {
    en: () => import('./application-page-en'),
    es: () => import('./application-page-es'),
  },
});